import type { Column } from '@/components/Organisms/DataTable/DataTable.types';

export const columns: Column[] = [
	{
		key: 'userEmail',
		label: 'User Email',
		width: '180px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'fullName',
		label: 'Full Name',
		width: '140px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'module',
		label: 'Module',
		width: '170px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'action',
		label: 'Action',
		width: '200px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'entityName',
		label: 'Entity',
		width: '180px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'clinicName',
		label: 'Clinic',
		width: '150px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'ipAddress',
		label: 'IP Address',
		width: '130px',
		type: 'string',
		sorter: false,
	},
	{
		key: 'OS',
		label: 'OS',
		width: '100px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'platform',
		label: 'Platform',
		width: '100px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'Port',
		label: 'Port',
		width: '120px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'userType',
		label: 'User Type',
		width: '120px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'state',
		label: 'State',
		width: '120px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'country',
		label: 'Country',
		width: '120px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'createdAt',
		label: 'Created At',
		width: '100px',
		type: 'date',
		dateISO: true,
		sorter: true,
	},
	{
		key: 'lastActive',
		label: 'Last Active',
		width: '170px',
		type: 'date',
		dateISO: true,
		sorter: false,
	},
	{
		key: 'time',
		label: 'Time',
		width: '100px',
		type: 'string',
		hideColumnFilter: true,
	},
];

